import { render } from "./Tasks_job.vue?vue&type=template&id=f2093446&scoped=true"
import script from "./Tasks_job.vue?vue&type=script&lang=js"
export * from "./Tasks_job.vue?vue&type=script&lang=js"

import "./Tasks_job.vue?vue&type=style&index=0&id=f2093446&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2093446"]])

export default __exports__